import React from 'react'
import Widget from '../../elements/Widget'

const Index = () => (
  <div className="row">
    <div className="col">
      <Widget title="Empty page" description="This is an empty page" />
    </div>
  </div>
)
export default Index
